export const OPTION = 1;
export const ACCESSORY = 2;
export const DEALER_INVENTORY = 3;
export const DEALER_DISCOUNT = 4;
export const EXTERIOR_COLOUR = 5;
export const INTERIOR_TRIM = 6;

export const ITEM_SOURCE = {
    DEALER: 4,
    SUPPLIER: 7,
};

export default {
    OPTION,
    ACCESSORY,
    DEALER_INVENTORY,
    DEALER_DISCOUNT,
    EXTERIOR_COLOUR,
    INTERIOR_TRIM,
    ITEM_SOURCE,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js